import { includes, isNil } from 'lodash-es';

export const isTestStatusSuccessful = (status?: string) => {
	if (isNil(status)) {
		return false;
	}
	return includes(
		['success', 'successful', 'pass', 'passed', 'succeeded'],
		status.toLowerCase()
	);
};
